import React,{useState,useEffect} from 'react'

let globalState = {};
const listeners = new Set();


export const createGlobalState = (initialState) => {
  globalState = initialState;

  const useGlobalState = () => {
    const [state, setState] = useState(globalState);

    useEffect(() => {
      const listener = (newState) => setState(newState);
      listeners.add(listener);
      return () => listeners.delete(listener);
    }, []);

    return [state, (newState) => {
      globalState = typeof newState === 'function' ? newState(globalState) : newState;
      listeners.forEach(listener => listener(globalState));
    }];
  };

  return useGlobalState;
};